/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { PLANOGRAM_CHANGE_DETAILS_FRAGMENT } from '../fragments/PlanogramChangeDetailsFragment'

export const GET_DISPLAY_PLANOGRAM_PERFORMANCE_HISTORY = gql`
  query GetDisplayPlanogramPerformanceHistory(
    $displayId: ID!
    $pagination: OffsetLimitPaginationFilter
  ) {
    displayPlanogramHistoryCount(displayId: $displayId)
    displayPlanogramPerformanceHistory(
      displayId: $displayId
      pagination: $pagination
    ) {
      performanceStartAt
      performanceEndAt
      measuredDays
      totalRevenue
      averageDailyRevenue
      change {
        ...PlanogramChangeDetails
      }
    }
  }
  ${PLANOGRAM_CHANGE_DETAILS_FRAGMENT}
`
